<template>
  <div class="controller-info">
    <p v-if="versionData">
      {{ t('app.fitbike.version', { version: versionData.version }) }}
    </p>

    <BikeFunctions />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useMqttStore } from '@/store/mqttStore'
import { storeToRefs } from 'pinia'
import BikeFunctions from '@/components/controls/BikeFunctions.vue'
import { MqttTopic } from '@/mqttDefinitions/topics'

const mqttStore = useMqttStore()
const { t } = useI18n()

const { doSubscribe, client } = mqttStore
const versionTopic = MqttTopic.CONTROLLER_VERSION

const { getRawValueOnTopic } = storeToRefs(mqttStore)

doSubscribe(versionTopic, client)

const versionData = computed(() => {
  const rawValue = getRawValueOnTopic.value(versionTopic)

  if (
    rawValue &&
    typeof rawValue === 'object' &&
    'version' in rawValue &&
    typeof rawValue.version === 'string'
  ) {
    return rawValue as { version: string }
  }

  return null
})
</script>

<style lang="scss"></style>
